module.exports = __webpack_public_path__ + "img/background_14.64b6739a.jpg";